/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandLeft = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 16.038C22 19.325 19.31 22 16.002 22H14c-1.654 0-3-1.338-3-2.982 0-.348.06-.683.171-.994H10c-1.654 0-3-1.338-3-2.982 0-.348.06-.683.171-.994H5c-1.654 0-3-1.338-3-2.982 0-1.644 1.346-2.982 3-2.982h4.586l-.793-.788a3.093 3.093 0 0 1 0-4.387C9.382 2.322 10.166 2 11 2s1.618.322 2.207.909l1.5 1.49 3.146 2.676A11.765 11.765 0 0 1 22 16.038zm-9-3.978v1.988h-3c-.552 0-1 .445-1 .994s.448.994 1 .994h5v1.988h-1c-.552 0-1 .445-1 .994 0 .549.448.994 1 .994h2.002c2.204 0 3.998-1.782 3.998-3.974a9.783 9.783 0 0 0-3.448-7.453L13.35 5.857l-1.557-1.543A1.119 1.119 0 0 0 11 3.988a1.116 1.116 0 0 0-.793 1.902l2.5 2.485a.985.985 0 0 1 .217 1.084 1 1 0 0 1-.924.613H5c-.552 0-1 .445-1 .994s.448.994 1 .994z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHandLeft as HandLeft };
